import PlaceholderImage from "../../products/PlaceholderImage";
import heroImage from "../../../assets/smarthome/Hero_avec_ombres.jpg";

export default function ContactUs(props) {
  const { textContent, language } = { ...props };

  return (
    <section className="container contact-section">
      <a
        href="https://www.polynhome.io/nous-contacter/"
        className="contact-button"
      >
        {textContent.contactUsSection.title[language]}
      </a>
    </section>
  );
}
